"use client";
// Imports
import { Container } from "@/components";

// Heading
export function Heading({ name }) {
  return (
    <Container>
      <div
        className="pt-6 lg:pt-12 animate-section-in"
        style={{ "--anim-delay": "150ms" }}
      >
        <h1 className="level-1">{name}</h1>
      </div>
    </Container>
  );
}
